/* eslint-disable no-unused-vars */
import React, { useRef, useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  AppBar,
  Badge,
  ClickAwayListener,
  Hidden,
  IconButton,
  Input,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Popper,
  Toolbar,
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { NotificationsPopover } from '../index';
import { useInjectReducer } from '../../store/injectReducer';
import { useInjectSaga } from '../../store/injectSaga';
import saga from '../../appContainer/saga';
import reducer from '../../appContainer/reducer';
import { createStructuredSelector } from 'reselect';
import { getRolesSelector, getUserSelector, isLoggedInSelector } from '../../appContainer/selectors';
import UserProfileMenu from '../UserProfileMenu/UserProfileMenu';
import useStyles from './styles';
import Typography from '@material-ui/core/Typography';
import bloodpressure from '../../assets/icons/notifications.svg';
import { getAllNotificationsSelector } from '../../views/Notifications/selectors';
import { WATCHUSER_ROLE_GROUP } from '../../utils/constants';
import { useIntl } from 'react-intl';
import { FontDownloadSharp, ZoomInSharp, ZoomOutSharp } from '@material-ui/icons';

const key = 'global';

const stateSelector = createStructuredSelector({
  isLoggedIn: isLoggedInSelector,
  loggedInUser: getUserSelector,
  notifications: getAllNotificationsSelector,
  roles: getRolesSelector
});

const FONT_SIZE = ["small", "large"]
const FONT_ICON = [ZoomInSharp, ZoomOutSharp]

const TopBar = props => {
  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });
  const { onOpenNavBarMobile, className, ...rest } = props;

  const classes = useStyles();
  const history = useHistory();
  const intl = useIntl();

  const currentFontSize = localStorage.getItem("fontSize")
  let selectedIndex = FONT_SIZE.findIndex(a => a === currentFontSize)
  selectedIndex = selectedIndex === -1 ? 0 : selectedIndex
  const SelectedIcon = FONT_ICON[selectedIndex]

  const searchRef = useRef(null);

  const notificationsRef = useRef(null);
  const [openSearchPopover, setOpenSearchPopover] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [openNotifications, setOpenNotifications] = useState(false);

  const { loggedInUser, isLoggedIn, notifications, roles } = useSelector(stateSelector);

  const handleNotificationsOpen = () => {
    setOpenNotifications(true);
  };

  const handleLogin = () => {
    history.push('/auth/login');
  };

  const handleNotificationsClose = () => {
    setOpenNotifications(false);
  };

  const handleSearchChange = event => {
    setSearchValue(event.target.value);

    if (event.target.value) {
      if (!openSearchPopover) {
        setOpenSearchPopover(true);
      }
    } else {
      setOpenSearchPopover(false);
    }
  };

  const handleSearchPopverClose = () => {
    setOpenSearchPopover(false);
  };

  const handleFontSizeChange = () => {
    let currentIndex = FONT_SIZE.findIndex(a => a === currentFontSize)
    if (currentIndex === -1) {
      currentIndex = 0
    }

    currentIndex = (currentIndex + 1) % FONT_SIZE.length

    const fontSizeNow = FONT_SIZE[currentIndex]
    localStorage.setItem("fontSize", fontSizeNow)
    window.location.reload()
  }

  const popularSearches = ['Devias React LoginRequired', 'Devias', 'Admin Pannel', 'Project', 'Pages'];

  const newNotifCount = (notifications || []).filter(notif => !notif.acknowledged).length;
  const currentUserRole = (roles || {})[loggedInUser.role];

  const showSearchBar = !WATCHUSER_ROLE_GROUP.includes(currentUserRole);

  const homespageROute = WATCHUSER_ROLE_GROUP.includes(currentUserRole) ? "/user/overview" : "/admin/dashboard";

  return (
    <AppBar {...rest} className={clsx(classes.root, className)} color="primary">
      <Toolbar>
        <RouterLink style={{ display: 'flex', alignItems: 'center' }} to={homespageROute}>
          <img
            alt="Watch My Health"
            src="/images/wmh-logo.png"
            style={{ height: '54px', width: '20vw', maxWidth: '180px' }}
          />
        </RouterLink>
        <div className={classes.flexGrow} />

        {
          showSearchBar && <Hidden smDown>
            <div ref={searchRef} className={classes.search}>
              <SearchIcon className={classes.searchIcon} />
              <Input
                className={classes.searchInput}
                disableUnderline
                onChange={handleSearchChange}
                placeholder={intl.formatMessage({id: "topbar.searchbar.placeholder", defaultMessage: "Search"})}
                value={searchValue}
              />
            </div>
            <Popper anchorEl={searchRef.current} className={classes.searchPopper} open={openSearchPopover} transition>
              <ClickAwayListener onClickAway={handleSearchPopverClose}>
                <Paper className={classes.searchPopperContent} elevation={3}>
                  <List>
                    {popularSearches.map(search => (
                      <ListItem key={search} button onClick={handleSearchPopverClose}>
                        <ListItemIcon>
                          <SearchIcon />
                        </ListItemIcon>
                        <ListItemText primary={search} />
                      </ListItem>
                    ))}
                  </List>
                </Paper>
              </ClickAwayListener>
            </Popper>
          </Hidden>
        }

        <IconButton
          ref={notificationsRef}
          className={classes.notificationsButton}
          color="inherit"
          onClick={handleNotificationsOpen}>
          <Badge
            badgeContent={newNotifCount}
            classes={{ badge: classes.notificationsBadge }}
            showZero={false}>
               <img src={bloodpressure} alt="icon" style={{height: `40px`,
            width: `40px`,position:`relative`, top: `0px`,
            left: `10`, }} />
          </Badge>
        </IconButton>

        {isLoggedIn ? (
          <UserProfileMenu user={loggedInUser || {}} />
        ) : (
          <Typography className={classes.loginText} onClick={handleLogin} variant="body1">
            {intl.formatMessage({id: "topbar.loginButton.label", defaultMessage: "LOGIN"})}
          </Typography>
        )}
        <Hidden lgUp>
          <IconButton color="inherit" onClick={onOpenNavBarMobile}>
            <MenuIcon />
          </IconButton>
        </Hidden>
        <div className={classes.fontSizeIcons} onClick={handleFontSizeChange}>
          <FontDownloadSharp/>
          <SelectedIcon/>
        </div>
      </Toolbar>

      <NotificationsPopover
        anchorEl={notificationsRef.current}
        onClose={handleNotificationsClose}
        open={openNotifications}
      />
    </AppBar>
  );
};

TopBar.propTypes = {
  className: PropTypes.string,
  onOpenNavBarMobile: PropTypes.func,
};

export default TopBar;
